import React from 'react';
import { Modal } from 'react-bootstrap';
import { FaCreditCard, FaChevronDown } from 'react-icons/fa';
import { SiContactlesspayment } from 'react-icons/si';
import { currencySymbolLeft } from '../../../../functions/Functions';
import './CardPaymentModal.css';

const DEFAULT_CARD_TAP_IMAGE = "/assets/img/default-item.jpeg";

const CardPaymentModal = ({
  isOpen,
  step = 'tap_card',
  amount = 0,
}) => {
  const formattedAmount = typeof amount === 'number' ? amount.toFixed(2) : amount;

  return (
    <Modal
      show={isOpen}
      backdrop="static"
      keyboard={false}
      centered
      dialogClassName="card-payment-dialog mx-auto"
      contentClassName="border-0 shadow-lg card-payment-content"
      className="card-payment-modal"
      backdropClassName="card-payment-backdrop"
      style={{ zIndex: 1070 }}
    >
      <div className="modal-body py-4 px-4 text-center">
        {/* Top Header Icon */}
        <div className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3 card-payment-icon-wrap">
          <FaCreditCard size={28} className="card-payment-top-icon" />
        </div>

        {/* Heading */}
        <h4 className="card-payment-title font-weight-bold mb-1">
          {step === 'processing' ? 'Processing Order...' : 'Please Tap Card Below'}
        </h4>

        {/* Subtitle / Instructions */}
        <p className="card-payment-desc text-muted mb-3">
          {step === 'processing'
            ? 'Payment approved! Please wait while we place your order.'
            : 'Please tap or swipe your card on the POS machine below to pay.'}
        </p>

        {/* Amount Badge */}
        {amount > 0 && (
          <div className="mb-3">
            <span className="card-payment-amount-badge font-weight-bold">
              Total Amount: {currencySymbolLeft()} {formattedAmount}
            </span>
          </div>
        )}

        {/* Contactless Tap Area or Custom Image */}
        <div className="card-payment-tap-card mx-auto position-relative d-flex flex-column align-items-center justify-content-center">
          <div className="contactless-waves-glow"></div>
          <div className="contactless-icon-circle d-flex align-items-center justify-content-center">
            <SiContactlesspayment size={48} className="contactless-main-icon" />
          </div>
          <span className="contactless-tap-label mt-2 font-weight-bold">
            Tap Card on Terminal
          </span>
        </div>

        {/* Downward indicator arrow to physical machine */}
        {step !== 'processing' && (
          <div className="card-tap-arrow-wrap mt-2 mb-2">
            <FaChevronDown className="card-tap-down-arrow" size={20} />
          </div>
        )}

        {/* Status pill */}
        <div className="mt-3">
          {step === 'processing' ? (
            <div className="card-payment-status-pill processing d-inline-flex align-items-center px-3 py-2">
              <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
              <span className="font-weight-bold" style={{ fontSize: '14px' }}>Confirming order...</span>
            </div>
          ) : (
            <div className="card-payment-status-pill waiting d-inline-flex align-items-center px-3 py-2">
              <span className="card-payment-live-dot mr-2"></span>
              <span className="font-weight-bold" style={{ fontSize: '14px' }}>Waiting for card tap...</span>
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default React.memo(CardPaymentModal);
